
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Category } from './types';
import { CategoryFormFields } from './components/CategoryFormFields';
import { useCategoryForm } from './hooks/useCategoryForm';

interface CategoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentCategory: Partial<Category> | null;
  isEditing: boolean;
  onSuccess: () => void;
}

export const CategoryDialog: React.FC<CategoryDialogProps> = ({
  open,
  onOpenChange,
  currentCategory,
  isEditing,
  onSuccess,
}) => {
  const {
    category,
    setCategory,
    handleNameChange,
    handleSaveCategory
  } = useCategoryForm({
    currentCategory,
    isEditing,
    onSuccess,
    onClose: () => onOpenChange(false)
  });

  if (!category) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{isEditing ? 'Edit' : 'Create'} Category</DialogTitle>
        </DialogHeader>
        
        <CategoryFormFields 
          category={category}
          onNameChange={handleNameChange}
          onCategoryChange={setCategory}
        />
        
        <div className="flex justify-end space-x-2 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleSaveCategory}>Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
